/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "Acerca de";
var Access = "Acceso";
var Account = "Cuenta";
var Actions = "Acciones";
var Active = "Activo";
var Add = "Añadir";
var Address = "Dirección";
var Advanced = "Avanzado";
var Aliases = "Alias";
var all = "todo";
var All = "Todos";
var Apply = "Aplicar";
var April = "Abril";
var Arbitrary = "Arbitrario";
var Assign = "Asignar";
var August = "Agosto";
var Back = "Atrás";
var Basic = "Básico";
var BNPP_EU = "BNPP_EU";
var Cancel = "Cancelar";
var Category = "Categoría";
var Classic = "Clásico";
var Clear = "Borrar";
var CLI = "CLI";
var Close = "Cerrar";
var Clusters = "Clústeres";
var code = "código";
var Complete = "Completado";
var Completed = "Completado";
var Compliance = "Conformidad";
var Compliant = "Conforme";
var Configuration = "Configuración";
var Configure = "Configurar";
var Confirm = "Confirmar";
var Connect = "Conectar";
var Connected = "Conectado";
var Connecting = "Establecimiento de la conexión";
var Containers = "Contenedores";
var Country = "País";
var Create = "Crear";
var Created = "Creado";
var Creating = "Creando";
var Critical = "Crítico";
var Current = "Actual";
var Custom = "Personalizado";
var Dallas = "Dallas";
var Datacenter = "Centro de datos";
var Datacenters = "Centros de datos";
var December = "Diciembre";
var Delete = "Suprimir";
var Deleting = "Suprimiendo";
var Deploying = "Despliegue";
var Disabled = "Inhabilitado";
var Disconnect = "Desconectar";
var Docs = "Documentación";
var Documentation = "Documentación";
var Done = "Terminado";
var Download = "Descargar";
var Draft = "Cheque";
var Edit = "Editar";
var Enabled = "Habilitada";
var Encryption = "Cifrado";
var End = "Fin";
var Enterprise = "Enterprise";
var Establish = "Establecer";
var Expired = "Caducado";
var Failed = "Error";
var February = "Febrero";
var Filter = "Filtro";
var Filters = "Filtros";
var Finalizing = "Finalizando";
var Frankfurt = "Frankfurt";
var Free = "Gratuito";
var Friday = "Viernes";
var Geography = "Área geográfica";
var Help = "Ayuda";
var hour = "hour";
var Hour = "Hora";
var hr = "hr";
var IAM = "IAM";
var ID = "ID";
var Images = "Imágenes";
var Inactive = "Inactivo";
var Incomplete = "Incompleto";
var Information = "Información";
var Infrastructure = "Infraestructura";
var Instance = "Instancia";
var Instances = "Instancias";
var Integrations = "Integraciones";
var Invalid = "No válido";
var January = "Enero";
var July = "Julio";
var June = "Junio";
var Key = "Clave";
var Launch = "Iniciar";
var Lite = "Lite";
var Loading = "Cargando";
var Location = "Ubicación";
var Locations = "Ubicaciones";
var Logging = "Registro";
var London = "Londres";
var March = "Marzo";
var May = "Mayo";
var Metro = "Área metropolitana";
var Minute = "Minuto";
var mo = "mo";
var Monday = "Lunes";
var Monitoring = "Supervisión";
var Month = "Mes";
var more = "more";
var Name = "Nombre";
var Namespace = "Espacio de nombres";
var Namespaces = "Espacios de nombres";
var Next = "Siguiente";
var No = "No";
var None = "Ninguna";
var Normal = "Normal";
var Note = "Nota";
var Notification = "Notificación";
var November = "Noviembre";
var Objects = "Objetos";
var October = "Octubre";
var Off = "Desactivado";
var OK = "OK";
var On = "Activar";
var Open = "Abrir";
var Osaka = "Osaka";
var Overview = "Visión general";
var Packages = "Paquetes";
var Pattern = "Patrón";
var Pending = "Pendiente";
var Plan = "Plan";
var Premium = "Premium";
var Previous = "Anterior";
var Product = "Producto";
var Products = "Productos";
var Project = "Proyecto";
var Projects = "Proyectos";
var Property = "Propiedad";
var provided = "proporcionada";
var Provider = "Proveedor";
var Provisioning = "Suministro de";
var Ready = "Preparado";
var Refresh = "Renovar";
var region = "región";
var Region = "Región";
var Remove = "Eliminar";
var Renew = "Renovar";
var Repositories = "Repositorios";
var Requested = "Solicitada";
var Required = "Obligatorio";
var Reservations = "Reservas";
var Reset = "Restablecer";
var resources = "recursos";
var Resources = "Recursos";
var Results = "Resultados";
var Review = "Revisar";
var Routing = "Direccionamiento";
var Satellite = "Satellite";
var Saturday = "Sábado";
var Save = "Guardar";
var Scanning = "Explorando";
var Schedule = "Planificación";
var Search = "Búsqueda";
var Secret = "Secreto";
var Select = "Select";
var Sending = "Enviando";
var September = "Septiembre";
var Serverless = "Sin servidor";
var Service = "Servicio";
var Settings = "Valores";
var Size = "Tamaño";
var Sort = "Ordenar";
var Source = "Origen";
var Start = "Iniciar";
var State = "Estado";
var Status = "Estado";
var Storage = "Almacenamiento";
var Submit = "Enviar";
var Subscription = "Suscripción";
var Success = "Correcto";
var Summary = "Resumen";
var Sunday = "Domingo";
var Sydney = "Sydney";
var tag = "etiqueta";
var tags = "etiquetas";
var Tags = "Etiquetas";
var Thursday = "Jueves";
var Tokyo = "Tokio";
var Topics = "Temas";
var Toronto = "Toronto";
var Total = "Total";
var Trash = "Papelera";
var Trial = "Prueba";
var Tuesday = "Martes";
var Unknown = "Desconocido";
var Unsupported = "No soportado";
var Update = "Actualizar";
var Upgrade = "Actualizar";
var Value = "Valor";
var Values = "Valores";
var Version = "Versión";
var View = "Ver";
var Warning = "Aviso";
var Wednesday = "Miércoles";
var Workloads = "Cargas de trabajo";
var Yes = "Sí";
var Zone = "Zona";
var Zones = "Zonas";
var es = {
	"'{{namespace}}' already exists. Enter another name.": "{{namespace}}' ya existe. Especifique otro nombre.",
	"'Day of week' matches in addition to 'Day of month'": "Coincidencias de 'Día de la semana' además de 'Día del mes'",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "Coincidencias de 'Día de la semana' además de 'Día del mes'. La expresión se desencadena cada día.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} elementos seleccionados",
	"{{count}} resources": "{{count}} recursos",
	"{{count}} resources included": "{{count}} recursos incluidos",
	"{{current}} of {{total}} pages": "{{current}} de {{total}} páginas",
	"{{datahookName}} response": "Respuesta de {{datahookName}}",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} patrones",
	"{{min}}–{{max}} items": "{{min}}–{{max}} elementos",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} de {{total}} elementos",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} módulos, {{resourcesCount}} recursos",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} requiere las siguientes opciones para poder desplegarse.",
	"{{price}} per {{unit}}": "{{price}} por {{unit}}",
	"{{price}} per month": "{{price}} al mes",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mes",
	"{{resourcesCount}} resources": "{{resourcesCount}} recursos",
	"{{rolesCount}} Role": "{{rolesCount}} rol",
	"{{rolesCount}} Roles": "{{rolesCount}} roles",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} tema activo para esta instancia.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} temas activos para esta instancia.",
	"{{value}} percent status progress": "{{value}} porcentaje de progreso de estado",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (crear un nuevo clúster para probar esta versión beta)",
	"{{version}} (update to an earlier version first)": "{{version}} (primero actualice a una versión anterior)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Debe tener una instancia de Cloud Object Storage para crear una ubicación de Satellite.</span> <a>Más información.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / instancia",
	"1 item selected": "1 elemento seleccionado",
	"1 of 1 page": "1 de 1 página",
	"1 role": "1 rol",
	"1–1 of 1 item": "1–1 de 1 elemento",
	"A collection of keys that belong to your service instance.": "Una colección de claves que pertenecen a la instancia de servicio.",
	"A key can only have 5 aliases.": "Una clave sólo puede tener 5 alias.",
	"A Key Protect key": "Una clave de Key Protect",
	"A location name is required. ": "Es necesario un nombre de ubicación. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "Un servicio de gestión de claves de varios arrendatarios. Cree y gestione claves criptográficas para cifrar datos en las aplicaciones y controlar el acceso a los datos.",
	"A name is required.": "Se necesita un nombre.",
	"A rotation policy of 12 months is recommended": "Se recomienda una política de rotación de 12 meses",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "Se requiere una autorización de servicio a servicio entre {{sourceServiceDisplayName}} y {{serviceDisplayName}} para asociar la clave de cifrado. Key Protect creará una con su consentimiento. O puede crear uno manualmente.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "Un servicio de gestión de claves de un solo arrendatario. Cree y gestione claves criptográficas con el blindaje de clave proporcionado por el módulo de seguridad de hardware controlado por el cliente dedicado. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "Una etiqueta solo puede incluir caracteres alfanuméricos, espacios, guiones bajos, guiones, puntos y un carácter de dos puntos.",
	"A tag cannot end with a colon.": "Una etiqueta no puede acabar en un carácter de dos puntos.",
	"A tag cannot include more than 128 characters.": "Una etiqueta no puede incluir más de 128 caracteres.",
	"A tag cannot start with a colon.": "Una etiqueta no puede empezar por un carácter de dos puntos.",
	"A tag should not have spaces around a colon.": "Una etiqueta no debe tener espacios alrededor de dos puntos.",
	About: About,
	Access: Access,
	"Access management tags": "Etiquetas de gestión de acceso",
	"Access management tags (optional)": "Etiquetas de gestión de acceso (opcional)",
	"Access management tags help you apply flexible access policies on specific resources.": "Las etiquetas de gestión de accesos le ayudan a aplicar políticas de acceso flexibles en recursos específicos.",
	Account: Account,
	"Account type": "Tipo de cuenta",
	"Action required": "Acción necesaria",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Promociones activas",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La recopilación de sucesos de Activity Tracker está habilitada para este recurso y se envía a los destinos definidos por la configuración de direccionamiento.",
	"Activity tracker events": "Sucesos de Activity Tracker",
	"Activity tracking": "Seguimiento de actividad",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Añada un solo espacio de nombres o varios espacios de nombres a la lista de espacios de nombres específicos.",
	"Add a single project or multiple projects to your specific project's list.": "Añada un solo proyecto o varios proyectos a la lista de su proyecto específico.",
	"Add Activity tracker event collection": "Añadir recopilación de sucesos de Activity Tracker",
	"Add activity tracking": "Añadir seguimiento de actividad",
	"Add event collection": "Añadir recopilación de sucesos",
	"Add hosts": "Añadir hosts",
	"Add hosts to meet the minimum service requirements.": "Añada hosts para cumplir los requisitos mínimos de servicio.",
	"Add key alias (optional)": "Añadir alias de clave (opcional)",
	"Add key description (optional)": "Añadir descripción de la clave (opcional)",
	"Add logging": "Añadir registro",
	"Add monitoring": "Añadir supervisión",
	"Add namespace": "Añadir espacio de nombres",
	"Add New": "Añadir nuevo",
	"Add project": "Añadir proyecto",
	"Add storage": "Añadir almacenamiento",
	"Add tags": "Añadir etiquetas",
	"Add to estimate": "Añadir a estimar",
	"Add to existing": "Añadir a existente",
	"Add to project": "Añadir al proyecto",
	"Adding ...": "Añadiendo...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Aborde las acciones necesarias siguientes para suministrar correctamente el servicio. Puede completar estos pasos ahora o después de crear el servicio.",
	"Address field": "Campo Dirección",
	Advanced: Advanced,
	"Advanced options": "Opciones avanzadas",
	"After connection": "Después de la conexión",
	"After the service cluster is created, assign storage to the cluster.": "Después de crear el clúster de servicio, asigne almacenamiento al clúster.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Después de desconectar Event Notifications, la instancia {{serviceName}} se elimina de la lista de servicios de origen de la instancia de Event Notifications.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Los alias sólo pueden contener caracteres alfanuméricos y -_.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Los alias deben tener un mínimo de 2 caracteres y un máximo de 90.",
	all: all,
	All: All,
	"All audit events (default target)": "Todos los sucesos de auditoría (objetivo predeterminado)",
	"All audit events from your account will be sent to a new instance": "Todos los sucesos de auditoría de su cuenta se enviarán a una nueva instancia",
	"All audit events from your account will be sent to an existing instance": "Todos los sucesos de auditoría de su cuenta se enviarán a una instancia existente",
	"All namespaces": "Todos los espacios de nombres",
	"All namespaces not supported": "No se da soporte a ningún espacio de nombres",
	"All platform logs": "Todos los registros de la plataforma",
	"All prerequisite services are installed on the location.": "Todos los servicios de requisito previo se instalan en la ubicación.",
	"All projects": "Todos los proyectos",
	"All projects not supported": "No se da soporte a ningún proyecto",
	"All regions": "Todas las regiones",
	"All resource groups": "Todos los grupos de recursos",
	"All secret groups": "Todos los grupos de secretos",
	"All types": "Todos los tipos",
	"All zone names must be unique": "Todos los nombres de zona deben ser exclusivos",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Acciones permitidas para el rol de {{roleName}} ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "¿Ya dispone de una cuenta? <a>Iniciar sesión</a>",
	"An error occurred when fetching secrets. Try again later.": "Se ha producido un error al recuperar secretos. Vuelva a intentarlo más tarde.",
	"An instance of Event Notifications <a>Create new instance</a>": "Una instancia de Event Notifications <a>Crear nueva instancia</a>",
	"An unexpected error occurred.": "Se ha producido un error inesperado.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analice y gestione los registros para la rápida resolución de problemas y la prevención proactiva del tiempo de inactividad. <a>Más información</a>",
	Apply: Apply,
	"Apply a code": "Aplicar un código",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "¿Está seguro de que desea desconectar la instancia {{serviceName}} de la instancia \"{{ENInstanceName}}\"?",
	"Are you sure you want to close the side panel?": "¿Seguro de que desea cerrar el panel lateral?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "¿Está seguro de que desea cerrar este panel? Cualquier selección que haya realizado se perderá.",
	"Are you sure?": "¿Está seguro?",
	Assign: Assign,
	"Associate key": "Asociar clave",
	"Attachment name": "Nombre de archivo adjunto",
	"Audit event collection is already enabled for this resource": "La recopilación de sucesos de auditoría ya está habilitada para este recurso",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "Se recomienda la recopilación de sucesos de auditoría para optimizar la resolución de problemas y reducir el tiempo de inactividad",
	"Audit events (error)": "Sucesos de auditoría (error)",
	"Audit events from {{region}} will be sent to a new instance": "Los sucesos de auditoría de {{region}} se enviarán a una nueva instancia",
	"Audit events from {{region}} will be sent to an existing instance": "Los sucesos de auditoría de {{region}} se enviarán a una instancia existente",
	"Audit events in {{region}}": "Sucesos de auditoría en {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Los sucesos de auditoría se recopilarán de los servicios IBM Cloud habilitados según el ámbito de direccionamiento definido.",
	"Audit events...": "Sucesos de auditoría...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "Se requiere autenticación o no tiene los permisos correctos para realizar esta acción.",
	"Authorization error": "Error de autorización",
	"Authorization met": "Se ha cumplido la autorización",
	"Authorization needed": "Autorización necesaria",
	"Authorize now": "Autorizar ahora",
	"Authorizing...": "Autorizando...",
	Back: Back,
	"Base URI": "URI base",
	"Base64 encoded key material": "Material de clave codificado en Base64",
	Basic: Basic,
	"Before you begin": "Antes de empezar",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Antes de que el proyecto pueda validar o desplegar configuraciones, el servicio de proyectos debe estar autorizado en esta cuenta para comunicarse con Schematics, Gestión de catálogos, Secrets Manager y Controlador de recursos. Un usuario con el acceso necesario a estos servicios puede otorgar autorizaciones automáticamente creando un proyecto en esta cuenta, o puede crear el servicio para las autorizaciones de servicio manualmente. Esta autorización solo es necesaria una vez.",
	"Billing information": "Información sobre facturación",
	"Billing period": "Periodo de facturación",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Nombre de grupo",
	"By {{name}}": "Por {{name}}",
	"By clicking Save, you are creating the following access:": "Si pulsa Guardar, creará el acceso siguiente:",
	"Can't retrieve details": "No se pueden recuperar detalles",
	Cancel: Cancel,
	"Cannot list integrations!": "No se puede mostrar la lista de integraciones.",
	"Cannot view keys in this instance": "No se pueden ver las claves en esta instancia",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Se aplican cargos. <a>Más información</a>",
	"Choose a cluster version": "Elija una versión de clúster",
	"Choose a key ring": "Elija un anillo de claves",
	"Choose a resource group": "Elija un grupo de recursos",
	"Choose account...": "Elegir cuenta...",
	"Choose an existing HPCS instance.": "Elija una instancia HPCS existente.",
	"Choose an existing Key Protect instance.": "Elija una instancia de Key Protect existente.",
	"Choose an instance": "Elija una instancia",
	"Choose an option": "Elegir una opción",
	"Choose category...": "Elegir categoría...",
	"Choose location": "Elegir ubicación",
	"Choose plan": "Elegir plan",
	"Choose property...": "Elegir propiedad...",
	"Choose provider...": "Elegir proveedor...",
	"Choose secret...": "Elegir secreto...",
	"Choose service instance...": "Elegir instancia de servicio...",
	"Choose source name...": "Elegir nombre de origen...",
	"Choose source...": "Elegir origen...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Elija la instancia de IBM Cloud Monitoring que recibirá las métricas de plataforma de las instancias de servicio habilitadas en IBM Cloud.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Elija la instancia de IBM Log Analysis que recibirá los registros de plataforma de las instancias de servicio habilitadas en IBM Cloud.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Borrar todo",
	"Clear all selected items": "Borrar todos los elementos seleccionados",
	"Clear filters": "Borrar filtros",
	"Clear selected": "Borrar la selección",
	"Clear selected item": "Borrar elemento seleccionado",
	"Clear selection": "Borrar selección",
	CLI: CLI,
	Close: Close,
	"Close menu": "Cerrar menú",
	"Close page navigation menu": "Cerrar menú de navegación por las páginas",
	"Close Panel": "Cerrar panel",
	"Close Push Panel": "Cerrar panel de envío",
	"Closing side panel": "Cerrando el panel lateral",
	"Cloud Logs": "Registros de Cloud",
	"Cloud Logs instance": "Instancia de Cloud Logs",
	"Cloud Logs instance name": "Nombre de instancia de Cloud Logs",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Instancia de Cloud Object Storage",
	"Cluster \"{{name}}\" is being deleted.": "Se está suprimiendo el clúster \"{{name}}\".",
	"Cluster management": "Gestión de clústeres",
	"Cluster version": "Versión de clúster",
	"Cluster version cannot be updated.": "No se puede actualizar la versión del clúster.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Ejemplo de código",
	"Collapse all rows": "Contraer todas las filas",
	"Collapse group": "Contraer grupo",
	"Collapse row": "Contraer fila",
	"Collapse summary": "Contraer resumen",
	"Compact (24px)": "Compacta (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Detalles de la configuración",
	"Configuration name": "Nombre de configuración",
	Configure: Configure,
	"Configure activity tracking": "Configurar el seguimiento de actividad",
	"Configure encryption": "Configurar el cifrado",
	"Configure logging": "Configurar registro",
	"Configure monitoring": "Configurar supervisión",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Conectar a Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Conecte su instancia {{serviceName}} a una instancia Event Notifications existente.",
	Connected: Connected,
	"Connected instance": "Instancia conectada",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "La instancia conectada de Event Notifications no existe. Póngase en contacto con el administrador.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Póngase en contacto con el administrador de la cuenta para acceder a un plan para suministrar Key Protect.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Póngase en contacto con el administrador de la cuenta para acceder a un grupo de recursos para suministrar Key Protect.",
	"Contact your administrator for access.": "Póngase en contacto con el administrador para obtener acceso.",
	"Contact your administrator for additional assistance.": "Póngase en contacto con el administrador para obtener más ayuda.",
	"Container registry": "Registro de contenedor",
	Containers: Containers,
	"Copied to clipboard": "Copiado en el portapapeles",
	"Copy to clipboard": "Copiar en el portapapeles",
	"Cost details": "Detalles de costes",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "No se ha podido cargar la información de precios. Renueve la página e inténtelo de nuevo más adelante.",
	Country: Country,
	Create: Create,
	"Create a key": "Crear una clave",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Cree un objetivo de direccionamiento de registros para dar soporte a la gestión y el análisis de registros para la resolución rápida de problemas y la prevención proactiva del tiempo de inactividad. <a>Más información</a>",
	"Create a new instance to get started.": "Cree una nueva instancia para empezar.",
	"Create a project": "Crear un proyecto",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Cree una ubicación de Satellite para llevar IBM Cloud a cualquier lugar. Para obtener más información, <a>consulte la documentación.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Cree un objetivo y una ruta de direccionamiento de eventos de Activity Tracker para dar soporte a la supervisión y auditoría de la actividad de IBM Cloud para mejorar la seguridad y el cumplimiento. <a>Más información</a>",
	"Create an encryption key or import your own key.": "Cree una clave de cifrado o importe su propia clave.",
	"Create cluster": "Crear clúster",
	"Create failed": "Creación fallida",
	"Create instance": "Crear instancia",
	"Create location": "Crear ubicación",
	"Create new": "Crear nuevo",
	"Create new instance": "Crear nueva instancia",
	"Create new key": "Crear una nueva clave",
	"Create new secret": "Crear un secreto nuevo",
	"Create reference": "Crear referencia",
	"Create resource": "Crear recurso",
	"Create Satellite location": "Crear ubicación de Satellite",
	"Create secret": "Crear un secreto",
	"Create services": "Creación de servicios",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Cree temas, destinos y suscripciones en Event Notifications para recibir notificaciones de los sucesos que genere su {{serviceName}}",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Creando...",
	"Creating...": "Creando...",
	Critical: Critical,
	"CRON expression": "Expresión CRON",
	Current: Current,
	Custom: Custom,
	"Custom access": "Acceso personalizado",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Bloque de argumentos de Datahook",
	"Datahook Params": "Parámetros de Datahook",
	"Datahook response": "Respuesta de Datahook",
	"Day of month": "Día del mes",
	"Day of Month (UTC)": "Día del mes (UTC)",
	"Day of week": "Día de la semana",
	"Day of week (UTC)": "Día de la semana (UTC)",
	December: December,
	"Dedicated hosts": "Hosts dedicados",
	"Default target": "Destino predeterminado",
	"Default title": "Título predeterminado",
	"Define project details": "Definir detalles del proyecto",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Defina las temporizaciones recurrentes de los sucesos generados por este suceso. Seleccione un patrón predefinido y personalícelo según sus necesidades. Las planificaciones se especifican en Hora Universal Coordinada (UTC).",
	"Define the scope of audit events collected": "Definir el ámbito de los sucesos de auditoría recopilados",
	Delete: Delete,
	"Delete cluster": "Suprimir clúster",
	"Delete failed": "Error al suprimir",
	"Delete retry wait": "Suprimir espera entre reintentos",
	"Delete the persistent storage used by this cluster": "Suprimir el almacén persistente utilizado por este clúster",
	Deleting: Deleting,
	"Deleting...": "Suprimiendo...",
	"Deploy failed": "Error al desplegar",
	"Deploy retry wait": "Desplegar espera entre reintentos",
	Deploying: Deploying,
	"Deployment ready": "Despliegue listo",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Versión en desuso, dejará de recibir soporte el {{when}}. Actualice la versión para que siga recibiendo soporte.",
	"Description (optional)": "Descripción (opcional)",
	"Description of the source": "Descripción del origen",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Desconectar Event Notifications",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "Las etiquetas de subdominio DNS no deben tener más de {{maxLength}} caracteres.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Edición finalizada",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "Durante la actualización, seguirán ejecutándose los recursos, apps, nodos trabajadores y maestro del clúster. Al finalizar la actualización, puede actualizar las versiones de los nodos trabajadores. Para obtener instrucciones y más información de las diferencias entre las versiones, <a>consulte la documentación</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Editar la integración de Activity Tracker",
	"Edit Array": "Editar matriz",
	"Edit columns": "Editar columnas",
	"Edit configuration": "Editar configuración",
	"Edit details": "Editar detalles",
	"Edit JSON": "Editar JSON",
	"Edit logging integration": "Editar integración de registros",
	"Edit secure value": "Editar valor seguro",
	"Edit tags": "Editar etiquetas",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Habilite las notificaciones del ciclo de vida para su instancia {{serviceName}} conectando una instancia de servicio Event Notifications.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Habilita la supervisión y la conformidad y audita las operaciones y el riesgo para gestionar su cuenta de IBM Cloud.",
	Encryption: Encryption,
	"Encryption key associated": "Clave de cifrado asociada",
	"Encryption options menu": "Menú de opciones de cifrado",
	End: End,
	"End date": "Fecha de finalización",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Mejore su experiencia con Schematics con integraciones. Empiece hoy mismo a añadir seleccionando una de las opciones siguientes.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Especifique el nombre de la configuración de la arquitectura desplegable.  Por ejemplo: production-vpc",
	"Enter a password": "Escriba una contraseña",
	"Enter a valid CRN": "Introduzca un CRN válido",
	"Enter array values. Quotations are added to values after you save.": "Especifique valores de matriz. Se añaden comillas a los valores después de que se guarden.",
	"Enter name and description": "Especifique el nombre y la descripción",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Especifique los nombres de las zonas de host. Para obtener una alta disponibilidad, asigne los hosts en estas tres zonas en función de las zonas del proveedor de la infraestructura. <a>¿Por qué necesito zonas?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Especifique los espacios de nombres separados por una coma. Después de pulsar Añadir, los nuevos espacios de nombres se incluirán en la lista y se seleccionarán automáticamente.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Especifique los proyectos separados por una coma. Después de pulsar Añadir, los proyectos se incluirán en la lista y se seleccionarán automáticamente.",
	"Enter source name": "Especifique el nombre de origen",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Especifique el nombre exacto de un grupo existente en la instancia de Cloud Object Storage. Si no se proporciona ningún nombre, se crea un nuevo grupo.",
	Enterprise: Enterprise,
	"Entire secret": "Secreto completo",
	"Environment (optional)": "Entorno (opcional)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Los entornos pueden contener propiedades que se comparten entre configuraciones relacionadas. Dentro de la configuración, puede modificar los valores proporcionados por el entorno. <a>Más información</a>",
	"Error": "Error",
	"Error checking existing services status": "Error al comprobar el estado de los servicios existentes",
	"Error checking host status": "Error al comprobar el estado del host",
	"Error checking storage status": "Error al comprobar el estado del almacenamiento",
	"Error fetching tags": "Error al captar etiquetas",
	"Error icon": "Icono de error",
	"Error loading accounts": "Error al cargar cuentas",
	"Error loading categories": "Error al cargar categorías",
	"Error loading groups": "Error al cargar grupos",
	"Error loading instances": "Error al cargar instancias",
	"Error loading keys": "Error al cargar claves",
	"Error loading pricing": "Error al cargar los precios",
	"Error loading properties": "Error al cargar propiedades",
	"Error loading providers": "Error al cargar proveedores",
	"Error loading regions": "Error al cargar regiones",
	"Error loading resource groups": "Error al cargar grupos de recursos",
	"Error loading S2S auth": "Error al cargar la autorización de S2S",
	"Error loading secrets": "Error al cargar secretos",
	"Error loading source names": "Error al cargar nombres de origen",
	"Error loading sources": "Error al cargar orígenes",
	"Error loading types": "Error al cargar tipos",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Se ha producido un error al validar este código. Asegúrese de que no incluye comillas en el código promocional.",
	Establish: Establish,
	"Estimate costs": "Costes estimados",
	"Estimated cost per instance": "Coste estimado por instancia",
	"Estimated starting cost": "Coste inicial estimado",
	"Estimated total ({{count}} instances)": "Total estimado ({{count}} instancias)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Instancia de Event Notifications",
	"Event Notifications service instance": "Instancia del servicio Event Notifications",
	"Event Source Manager": "Gestor de origen de sucesos",
	"Every 2 hours": "Cada 2 horas",
	"Every 2 minutes": "Cada 2 minutos",
	"Every 3 hours": "Cada 3 horas",
	"Every 4 hours": "Cada 4 horas",
	"Every 5 minutes": "Cada 5 minutos",
	"Every 6 hours": "Cada 6 horas",
	"Every 10 minutes": "Cada 10 minutos",
	"Every 15 minutes": "Cada 15 minutos",
	"Every day": "Cada día",
	"Every fifth day": "Cada cinco días",
	"Every fourth day": "Cada cuatro días",
	"Every fourth month": "Cada cuatro meses",
	"Every hour": "Cada hora",
	"Every minute": "Cada minuto",
	"Every month": "Cada mes",
	"Every second day": "Cada dos días",
	"Every second month": "Cada dos meses",
	"Every sixth month": "Cada seis meses",
	"Every third day": "Cada tres días",
	"Every third month": "Cada tres meses",
	"Examples: access:dev, proj:version-1": "Ejemplos: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Ejemplos: env:dev, version-1",
	"Existing instance": "Instancia existente",
	"Exiting encryption selection": "Salir de la selección de cifrado",
	"Expand all rows": "Expandir todas las filas",
	"Expand group": "Expandir grupo",
	"Expand row": "Expandir fila",
	"Expand summary": "Expandir resumen",
	Expired: Expired,
	"Expired (beta)": "Caducado (beta)",
	"Expires {{when}}": "Caduca {{when}}",
	"Expires after beta": "Caduca después de la versión beta",
	"Extra large (64px)": "Extra grande (64px)",
	"Extra small (24px)": "Extra pequeño (24px)",
	Failed: Failed,
	"Failed to check permission": "No se ha podido comprobar el permiso",
	"Failed to create configuration": "Error al crear la configuración",
	"Failed to create key": "Error al crear la clave",
	"Failed to create policy": "No se ha podido crear la política",
	"Failed to create project": "Error al crear el proyecto",
	"Failed to fetch": "No se ha podido recuperar",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "No se han podido obtener instancias de IBM Cloud Activity Tracker.",
	"Failed to fetch IBM Cloud Monitoring instances.": "No se han podido obtener las instancias de IBM Cloud Monitoring.",
	"Failed to fetch IBM Log Analysis instances.": "No se han podido obtener instancias de IBM Log Analysis.",
	"failure state": "estado de anomalía",
	February: February,
	"Fetch data": "Captar datos",
	Filter: Filter,
	"Filter instance by region": "Filtrar instancia por región",
	"Filter...": "Filtrar...",
	Filters: Filters,
	"Filters:": "Filtros:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Finalizando el clúster...",
	"Finalizing workers...": "Finalizando trabajadores...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "Obtenga visibilidad operativa de los recursos de la nube con IBM Cloud Activity Tracker.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "Obtenga visibilidad operativa de los recursos de la nube con IBM Cloud Monitoring.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "Obtenga visibilidad operativa de los recursos de la nube con IBM Log Analysis.",
	"Get started": "Cómo empezar",
	"Get started with Security and Compliance Center": "Cómo empezar con Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Asigne a su clave un alias para facilitar su recuperación posterior.",
	"Helm catalog": "Catálogo de Helm",
	Help: Help,
	"Hide password": "Ocultar contraseña",
	"Host usage\n(used / total)": "Uso de host (utilizado / total)",
	"Hosts needed": "Hosts necesarios",
	"Hosts requirements met": "Se han cumplido los requisitos de hosts",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Hora (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "Acepto utilizar mi señal para crear una política de servicio a servicio entre el servicio de origen {{sourceServiceDisplayName}} y el servicio de destino {{serviceDisplayName}} en mi nombre.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "Confirmo que quiero dejar de recibir registros de plataforma de {{instance}}",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "Confirmo que quiero dejar de recibir métricas de plataforma de {{instance}}",
	"IaaS ready": "IaaS listo",
	IAM: IAM,
	"IAM credentials": "Credenciales de IAM",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "Si no se asigna ningún conjunto de claves, la clave se añadirá al conjunto de claves predeterminado.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "Si se selecciona, la matriz se guardará como serie \"__NOT_SET__\".",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "Si el valor inicial no era una matriz de series válida, a continuación aparecerá una matriz de elementos vacía o única.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "Si las etiquetas de usuario están relacionadas con la facturación, considere la posibilidad de escribir las etiquetas como pares clave:valor, como por ejemplo",
	Images: Images,
	"Import your own key": "Importar su propia clave",
	"In progress": "En curso",
	"in progress state": "estado en curso",
	Inactive: Inactive,
	"inactive state": "estado inactivo",
	Incomplete: Incomplete,
	"incomplete state": "estado incompleto",
	Information: Information,
	"information state": "estado de información",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Zonas de infraestructura",
	Instance: Instance,
	"Instance ID": "ID de instancia",
	"Instance location": "Ubicación de instancia",
	"Instance name": "Nombre de instancia",
	"Instance(s) in {{region}}": "Instancia(s) en {{region}}",
	"Instance(s) in region": "Instancia(s) en la región",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Error de servidor interno. Espere un minuto y vuelva a intentar la acción. Si el problema persiste, abra una incidencia de soporte.",
	"Interpolated URI": "URI interpolado",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Objeto datahook no válido, se utilizan las últimas opciones válidas",
	"Invalid label name.": "Nombre de etiqueta no válido.",
	"Invalid label prefix or name.": "Prefijo o nombre de etiqueta no válido.",
	"Invalid label value.": "Valor de etiqueta no válido.",
	"Items per page:": "Elementos por página:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Alias de clave",
	"Key CRN": "CRN de clave",
	"Key description": "Descripción de clave",
	"Key description must be at least 2 characters and no more than 240 characters.": "La descripción de clave debe tener al menos 2 caracteres y no más de 240 caracteres.",
	"Key ID": "ID de clave",
	"Key management": "Gestión de claves",
	"Key management service": "Servicio de gestión de claves",
	"Key material": "Material de clave",
	"Key material is required to import a key": "Se necesita material de clave para importar una clave",
	"Key material length must be 128, 192, or 256 bits": "La longitud del material de la clave debe ser de 128, 192 o 256 bits",
	"Key material must be base64": "El material de la clave debe ser base64",
	"Key name": "Nombre de clave",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Nombre de instancia de Key Protect",
	"Key ring": "Conjunto de claves",
	"Key value": "Valor de clave",
	"Label must be of the form 'key:value'.": "La etiqueta debe tener el formato 'clave:valor'.",
	"Label name must be no more than {{maxLength}} characters.": "El nombre de etiqueta no debe tener más de {{maxLength}} caracteres.",
	"Label prefix must be a valid DNS subdomain.": "El prefijo de etiqueta debe ser un subdominio DNS válido.",
	"Label prefix must be no more than {{maxLength}} characters.": "El prefijo de etiqueta no debe tener más de {{maxLength}} caracteres.",
	"Label value must be no more than {{maxLength}} characters.": "El valor de etiqueta no debe tener más de {{maxLength}} caracteres.",
	"Large (48px)": "Grande (48px)",
	"Last modified": "Última modificación",
	"Last scanned": "Explorado por última vez",
	"Last updated": "Actualizado por última vez",
	Launch: Launch,
	"Launch activiting tracking": "Iniciar seguimiento de activación",
	"Launch in new window": "Abrir en una nueva ventana",
	"Launch logging": "Iniciar registro",
	"Launch monitoring": "Iniciar supervisión",
	"Learn more": "Más información",
	"learn more.": "más información.",
	"Learn more.": "Más información.",
	"List of actions": "Lista de acciones",
	"list of code sample types": "lista de tipos de ejemplo de código",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Indicador de carga",
	"Loading...": "Cargando...",
	"Locate by CRN within your account": "Localizar por CRN dentro de su cuenta",
	Location: Location,
	"Location summary": "Resumen de ubicación",
	"Location:": "Ubicación:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "La recopilación de registros ya está habilitada para este recurso",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La recopilación de registros está habilitada para este recurso y se envía a los destinos definidos por la configuración de direccionamiento.",
	Logging: Logging,
	"Logging (error)": "Registro (error)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "Se recomienda el registro para optimizar la resolución de problemas y reducir el tiempo de inactividad",
	"Logging...": "Registro...",
	London: London,
	"Looking for valid service to service authorization policy...": "Buscando una política válida de autorización de servicio a servicio...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Parece que le faltan los permisos necesarios para crear la política. Póngase en contacto con el administrador de su cuenta",
	"Looks like you don't have access to view account information.": "Parece que no tiene acceso para ver la información de la cuenta.",
	"Looks like you don't have access to view the billing period": "Parece que no tiene acceso para ver el periodo de facturación",
	"Looks like you don't have any scans": "Parece que no tiene ninguna exploración",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Parece que no tiene el acceso necesario para ver esta información. Póngase en contacto con el administrador de la cuenta para verificar los permisos.",
	"Looks like you don't have the correct access": "Parece que no tiene el acceso adecuado",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Parece que no tiene el acceso correcto. Debe tener acceso al servicio de destino para poder crear una autorización entre servicios.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Asegúrese de que tiene temas, suscripciones y destinos configurados en Event Notifications.",
	"Manage encryption by enabling a key management service (KMS).": "Gestione el cifrado habilitando un servicio de gestión de claves (KMS).",
	"Manage routing": "Gestionar direccionamiento",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Gestionar el ciclo de vida de las claves de cifrado que se utilizan para los recursos, servicios y aplicaciones de IBM Cloud.",
	"Managed from": "Gestionado desde",
	March: March,
	May: May,
	"Media gallery video": "Vídeo de la galería multimedia",
	"Medium (40px)": "Medio (40px)",
	"Metadata location": "Ubicación de metadatos",
	Metro: Metro,
	"Minimum host requirements are met.": "Se han cumplido los requisitos mínimos de host.",
	Minute: Minute,
	"Minute (UTC)": "Minuto (UTC)",
	"Missing prerequisite services": "Faltan servicios de requisito previo",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Modifique los argumentos pasados a su datahook aquí.",
	"Mon-Fri": "Lun-Vie",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Supervise la conformidad de todos los entornos configurando exploraciones.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Supervise y audite la actividad de IBM Cloud para mejorar la seguridad y el cumplimiento normativo. <a>Más información</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Mes (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "El nombre ya se está utilizando. Proporcione un nombre exclusivo.",
	"Name must be between 2 and 90 characters": "El nombre debe tener entre 2 y 90 caracteres",
	"Name this project": "Nombrar este proyecto",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "Nueva instancia",
	Next: Next,
	"Next page": "Página siguiente",
	"Next: Customize": "Siguiente: Personalizar",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "No hay regiones de catálogo disponibles",
	"No Cloud Object Storage instance is available.": "No hay ninguna instancia de Cloud Object Storage disponible.",
	"No code preview has been configured for terraform. Please visit our docs to ": "No se ha configurado ninguna vista previa de código para terraform. Visite nuestros documentos para ",
	"No configurations available": "No hay configuraciones disponibles",
	"No events can be scheduled with your selected CRON expression.": "No se puede planificar ningún suceso con la expresión CRON seleccionada.",
	"No Hyper Protect Crypto Services instances found": "No se han encontrado instancias de Hyper Protect Crypto Services",
	"No instances found": "No se han encontrado instancias.",
	"No item matches the filters. Clear the filters and try again.": "No hay ningún elemento que coincida con los filtros. Borre los filtros y vuelva a intentarlo.",
	"No items available to display. Select an instance and bucket to view objects.": "No hay elementos disponibles para visualizar. Seleccione una instancia y un grupo para ver los objetos.",
	"No items match the current filter.": "Ningún elemento coincide con el filtro actual.",
	"No keys available": "No hay ninguna clave disponible",
	"No matches found. To create new tags, contact your tag administrator.": "No se han encontrado coincidencias. Para crear nuevas etiquetas, póngase en contacto con el administrador de etiquetas.",
	"No matching options": "No hay opciones coincidentes",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "No hay ningún ID de región coincidente disponible en esta cuenta. Si cree que se trata de un error, renueve la página o póngase en contacto con el administrador.",
	"No plans found": "No se han encontrado planes",
	"No regions available": "No hay regiones disponibles",
	"No resource groups available": "No hay ningún grupo de recursos disponible",
	"No secret available": "No hay ningún secreto disponible",
	"No secret group available": "No hay ningún grupo de secretos disponible",
	"No service instance available": "No hay ninguna instancia de servicio disponible",
	"No valid version update options are available.": "No hay opciones de actualización de versión válidas disponibles.",
	"Non-compliant": "No compatible",
	None: None,
	"None available": "Ninguna disponible",
	Normal: Normal,
	"Normal (48px)": "Normal (48px)",
	"Not authorized": "No autorizado",
	"Not ready": "No preparado",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Objecto",
	"Object storage": "Almacenamiento de objetos",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "El almacenamiento de objetos se utiliza para almacenar datos sobre la ubicación y las copias de seguridad de los clústeres de la ubicación. <a>Más información.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Una vez al día",
	"Once a month": "Una vez al mes",
	"Once a week": "Una vez a la semana",
	"Once a year": "Una vez al año",
	Open: Open,
	"Open dashboard": "Abrir panel de control",
	"Open Dashboard": "Abrir panel de control",
	"Open menu": "Abrir menú",
	"Open page navigation menu": "Abrir menú de navegación por las páginas",
	"Open reference picker": "Abrir el selector de referencias",
	"Open tab list": "Abrir lista de pestañas",
	Osaka: Osaka,
	"Overflow menu": "Menú de desbordamiento",
	"Overflow Menu": "Menú de desbordamiento",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "página {{pageNumber}}",
	"Page Navigation": "Navegación por la página",
	"Page navigation menu": "Menú de navegación por las páginas",
	"Page number": "Número de página",
	Pattern: Pattern,
	"Pay-As-You-Go": "Pago por uso",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Acceso de plataforma",
	"Platform logs from {{region}} will be sent to a new instance": "Los registros de plataforma de {{region}} se enviarán a una nueva instancia",
	"Platform logs from {{region}} will be sent to an existing instance": "Los registros de plataforma de {{region}} se enviarán a una instancia existente",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "Los registros de plataforma de {{region}} se enviarán a la instancia de destino. <a>Más información</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "Los registros de la plataforma se recopilarán de los servicios IBM Cloud habilitados según el ámbito de direccionamiento definido.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "<a>Regístrese</a> para crear o <a>inicie sesión</a> antes de aplicar el código promocional.",
	"Prefix filter": "Filtro de prefijo",
	Premium: Premium,
	"Preparing master, workers...": "Preparando el maestro, trabajadores...",
	"Preparing master...": "Preparando maestro...",
	"Prerequisite services installed": "Servicios de requisito previo instalados",
	Previous: Previous,
	"Previous page": "Página anterior",
	"Pricing Plans": "Planes de precios",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Proporcione una descripción más detallada de la clave. Para proteger su privacidad, no utilice datos personales, como su nombre o ubicación, como descripción. No puede cambiar esto después de crear la clave.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Proporciona visibilidad del rendimiento y el estado de la aplicación de recursos basada en IBM Cloud.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "¿Listo para aplicarla?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Renovar instancias de Cloud Object Storage",
	"Refresh data": "Renovar datos",
	"Refresh secrets": "Renovar secretos",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Eliminar clasificación",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "La representación de ganchos de modificación no está soportada para evitar cambios de recursos inesperados.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Solicitando creación...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Restablecer filtros",
	"Reset to default": "Restablecer valores predeterminados",
	"Reset zoom": "Restablecer zoom",
	"Resource Configuration": "Configuración de recursos de",
	"Resource group": "Grupo de recursos",
	"Resource group:": "Grupo de recursos:",
	"Resource list": "Lista de recursos",
	"Resource List": "Lista de recursos",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Recursos no incluidos en el coste",
	"Restricted access": "Acceso restringido",
	Results: Results,
	"Retrying delete": "Reintentando suprimir",
	"Retrying deploy": "Reintentando desplegar",
	"Revert {{resetCount}} to default": "Revertir {{resetCount}} al valor predeterminado",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Revisar asignaciones de acceso a {{resourceDisplayName}}",
	"Review settings in Event Notifications": "Revisar los valores en Event Notifications",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Revise las siguientes políticas de grupo de acceso para asegurarse de que está asignando el nivel de acceso adecuado.",
	"Rotation interval": "Intervalo de rotación",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "Las políticas de rotación determinan el intervalo entre rotaciones de clave automáticas. Un intervalo de un mes, por ejemplo, significa que una clave se rotará cada 30 días. Si la política ya está habilitada, esto significa que existe una política de instancia para esta instancia y si no se realiza ninguna otra acción, el intervalo de rotación mostrado se aplicará a la clave. Si está inhabilitado, habilítelo para establecer una política para esta clave.",
	"Rotation policy": "Política de rotación",
	"Rotation policy disabled": "Política de rotación inhabilitada",
	"Route name": "Nombre de ruta",
	Routing: Routing,
	"Routing scope": "Ámbito de direccionamiento",
	"Row height": "Altura de fila",
	"Sample not yet available": "Muestra todavía no disponible",
	"Sao Paulo": "Sao Paulo",
	"Sat-Sun": "Sab-Dom",
	Satellite: Satellite,
	"Satellite container": "Contenedor de Satellite",
	"Satellite location": "Ubicación de Satellite",
	"Satellite location base cost": "Coste base de ubicación de Satellite",
	"Satellite location base functionality": "Funcionalidad base de ubicación de Satellite",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Guardando...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Los espacios de trabajo de Schematics y otros datos de proyecto se almacenan en la región y el grupo de recursos seleccionados. <a>Más información.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Los espacios de trabajo de Schematics se suministran en esta región. El proyecto todavía puede desplegar recursos en cualquier región.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Los espacios de trabajo de Schematics se suministran en este grupo de recursos. El proyecto puede seguir desplegando recursos en cualquier grupo de recursos.",
	Search: Search,
	"Search in this instance": "Buscar en esta instancia",
	Secret: Secret,
	"Secret configured": "Secreto configurado",
	"Secret group": "Seleccionar grupo",
	"Secret type": "Tipo de secreto",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Valor seguro",
	"See details": "Ver  detalles",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Seleccione una ubicación para ver qué pasos debe realizar a continuación.",
	"Select a project": "Seleccionar un proyecto",
	"Select a reference": "Seleccionar una referencia",
	"Select a region": "Seleccione una región",
	"Select a resource group": "Seleccione un grupo de recursos",
	"Select a role to determine the level of access for the source service.": "Seleccione un rol para determinar el nivel de acceso para el servicio de origen.",
	"Select a secret": "Seleccione un secreto",
	"Select a secret group": "Seleccione un grupo de secretos",
	"Select a service instance": "Seleccione una instancia de servicio",
	"Select all {{totalRowCount}} items": "Seleccionar los {{totalRowCount}} elementos",
	"Select all rows on page": "Seleccionar todas las filas de la página",
	"Select an environment": "Seleccione un entorno",
	"Select an existing configuration": "Seleccione una configuración existente",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "Seleccione una instancia de IBM Cloud Monitoring para recibir métricas de plataforma",
	"Select an IBM Log Analysis instance to receive platform logs": "Seleccione la instancia de IBM Log Analysis que recibirá los registros de plataforma",
	"Select an instance": "Seleccione una instancia",
	"Select an instance to show keys": "Seleccionar una instancia para mostrar claves",
	"Select an option...": "Seleccione una opción...",
	"Select existing key": "Seleccionar clave existente",
	"Select from Secrets Manager": "Seleccione en Secrets Manager",
	"Select KMS instance": "Seleccionar instancia KMS",
	"Select namespaces": "Seleccionar espacios de nombres",
	"Select one or more namespaces": "Seleccione uno o varios espacios de nombres",
	"Select one or more projects": "Seleccione uno o varios proyectos",
	"Select prerequisites": "Seleccionar requisitos previos",
	"Select projects": "Seleccionar proyectos",
	"Select region and resource group": "Seleccionar región y grupo de recursos",
	"Select row": "Seleccionar fila",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Seleccione la <a>región de IBM Cloud</a> más cercana al lugar donde reside la infraestructura para garantizar una latencia de red baja.",
	"Select the following tile to deploy it.": "Seleccione el siguiente mosaico para desplegarlo.",
	"Send all audit events from enabled resources in {{region}}.": "Envía todos los sucesos de auditoría de los recursos habilitados en {{region}}.",
	"Send all available audit events in this account.": "Envía todos los sucesos de auditoría disponibles en esta cuenta.",
	"Send events to": "Enviar sucesos a",
	"Send logs to": "Enviar registros a",
	"Send test notification": "Enviar notificación de prueba",
	Sending: Sending,
	"Sent!": "Enviado.",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Proyectos sin servidor",
	Service: Service,
	"Service access": "Acceso de servicio",
	"Service authorization": "Autorización de servicio",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "La autorización del servicio es necesaria para permitir que el direccionamiento de sucesos de Activity Tracker se comunique con Cloud Logs. Haga clic en <span>Autorizar ahora</span> para crear una política con ámbito para todos los recursos de Cloud Logs de esta cuenta.",
	"Service authorization required": "Se requiere una autorización de servicio",
	"Service instance": "Instancia de servicio",
	"Service name": "Nombre de servicio",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "Se debe proporcionar la autorización de servicio a servicio para la instancia. <a>Más información</a>",
	"Service to service authorization policy found": "Política de autorización de servicio a servicio encontrada",
	"Service to service authorization policy needed": "Se necesita una política de autorización de servicio a servicio",
	"Service type": "Tipo de servicio",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "No se ha podido verificar la autorización de servicio a servicio. Añada y compruebe manualmente los roles necesarios.",
	"Service-to-service authorization requirements are met.": "Se han cumplido los requisitos de autorización de servicio a servicio.",
	"Set an interval (in months)": "Establecer un intervalo (en meses)",
	"Set key rotation policy": "Establecer política de rotación de claves",
	"Set up auth": "Configurar autorización",
	Settings: Settings,
	"Short (32px)": "Baja (32px)",
	"Show all filters": "Mostrar todos los filtros",
	"Show code sample": "Mostrar ejemplo de código",
	"Show environments information": "Mostrar información sobre entornos",
	"Show error information": "Mostrar información sobre errores",
	"Show information": "Mostrar información",
	"Show less": "Mostrar menos",
	"Show more": "Mostrar más",
	"Show more details": "Mostrar más detalles",
	"Show password": "Mostrar contraseña",
	"Show tooltip": "Mostrar ayuda contextual",
	"Showing {{count}} item": "Mostrando {{count}} elemento",
	"Showing {{count}} items": "Mostrando {{count}} elementos",
	Size: Size,
	"Small (32px)": "Pequeño (32px)",
	"Some events from {{serviceName}}:": "Algunos sucesos de {{serviceName}}:",
	"Something went wrong": "Algo ha fallado",
	"Something went wrong.": "Algo ha fallado.",
	"Something went wrong. Try reloading the page to see this information": "Algo ha fallado. Intente volver a cargar la página para ver esta información",
	Sort: Sort,
	"Sort ascending": "Clasificar en orden ascendente",
	"Sort descending": "Clasificar en orden descendente",
	Source: Source,
	"Source Details": "Detalles de salida",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "El origen del servicio no existe en la instancia de Event Notifications. Póngase en contacto con el administrador.",
	"Source service": "Servicio de origen",
	"Specific namespaces not supported": "No se da soporte a espacios de nombres específicos",
	"Specific projects not supported": "No se da soporte a proyectos específicos",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Empiece por crear un clúster que sirva para ejecutar sus cargas de trabajo.",
	"Start date": "Fecha de inicio",
	"Starting at": "A partir de",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "Los costes iniciales se basan en esta configuración de recursos. Puede editar las configuraciones después de añadir este producto a un proyecto, lo que podría repercutir en los costes.",
	State: State,
	Status: Status,
	"status icon": "icono de estado",
	"Stay in pattern": "Permanecer en el patrón",
	"Steps complete": "Pasos completados",
	Storage: Storage,
	"Storage bucket (optional)": "Grupo de almacenamiento (opcional)",
	"Storage configuration missing": "Falta la configuración de almacenamiento",
	"Storage ready": "Almacenamiento preparado",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Almacene, busque, analice y supervise los datos y sucesos de registro de IBM Cloud y emita alertas sobre ellos.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "estado de éxito",
	"Success! This promotion was applied to your account.": "Correcto Esta promoción se ha aplicado a su cuenta.",
	"Successfully created new Key Protect instance": "Se ha creado satisfactoriamente una nueva instancia de Key Protect",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Plan de soporte",
	"Switch to folders view": "Cambiar a vista de carpetas",
	"Switch to objects view": "Cambiar a vista de objetos",
	Sydney: Sydney,
	"Syntax: ": "Sintaxis: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "La etiqueta '{{tagName}}' no se ha podido crear porque el nombre no es válido.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Las etiquetas:",
	"Tags: (optional)": "Etiquetas: (opcional)",
	"Tall (64px)": "Altura (64px)",
	"Target destination": "Destino de objetivo",
	"Target location": "Ubicación de destino",
	"Target name": "Nombre de destino",
	"Target selected": "Destino seleccionado",
	"Target service instance": "Instancia de servicio de destino",
	"Target type": "Tipo de destino",
	"Template error": "Error de plantilla",
	"Terms and conditions": "Términos y condiciones",
	"Test notification": "Notificación de prueba",
	"The address field is required.": "El campo de dirección es obligatorio.",
	"The catalog window might have been blocked from opening.": "Es posible que se haya bloqueado la apertura de la ventana de catálogo.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "La instancia de Event Notifications conectada se ha suprimido de la cuenta. Para continuar utilizando las notificaciones, desconecte la instancia actual pulsando Desconectar en el menú ( ⋮ ). A continuación, conecte otra instancia de Event Notifications.",
	"The description should not contain any leading or trailing whitespace characters.": "La descripción no puede contener ningún espacio en blanco inicial o final.",
	"The description should not exceed {{limit}} characters in length.": "La descripción no debe superar los {{limit}} caracteres de longitud.",
	"The following access is required:": "Se requiere el siguiente acceso:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "La siguiente vista previa de código muestra la solicitud correspondiente como mandatos de CLI. Utilícelo como punto de partida para escribir su propia automatización. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "La siguiente vista previa de código muestra la solicitud correspondiente como llamadas de API REST. Utilícelo como punto de partida para escribir su propia automatización. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "La siguiente vista previa de código muestra la solicitud correspondiente con Terraform. Utilícelo como punto de partida para escribir su propia automatización. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "La siguiente vista previa muestra la solicitud correspondiente como código. Utilícelo como punto de partida para escribir su propia automatización.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "Los recursos siguientes no se han incluido en la estimación de costes, pero podrían tener un coste asociado.",
	"The IAM role manager for {{serviceName}}": "El gestor de roles IAM para {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "No se puede acceder a la instancia porque se ha eliminado de la cuenta una autorización de servicio a servicio. Cree una autorización con acceso al Gestor de origen de sucesos entre {{sourceServiceName}} y Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "La lista de espacios de nombres no se puede cumplimentar. Vuelva a intentarlo más tarde.",
	"The list of projects can't be populated. Try again later.": "La lista de proyectos no se puede cumplimentar. Vuelva a intentarlo más tarde.",
	"The name is required.": "El nombre es necesario.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "El nombre debe tener {{max}} caracteres como máximo, empezar por una letra y contener solo caracteres alfanuméricos, '-' y '.'",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "El nombre de un espacio de nombres solo puede contener letras en minúscula, números y guiones. El nombre no puede empezar ni terminar por un guion y debe tener un máximo de 63 caracteres.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "El nombre de un proyecto solo puede contener letras en minúscula, números y guiones. El nombre no puede empezar ni terminar por un guion y debe tener un máximo de 63 caracteres.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "El nombre debe contener solo caracteres alfanuméricos, de subrayado, guiones y espacios.",
	"The name should not contain any special characters.": "El nombre no debe contener ningún carácter especial.",
	"The name should not exceed {{limit}} characters in length.": "El nombre no debe superar los {{limit}} caracteres de longitud.",
	"The region is required.": "La región es obligatoria.",
	"The resource group is required.": "El grupo de recursos es obligatorio.",
	"The resource group window might have been blocked from opening.": "Es posible que se haya bloqueado la apertura de la ventana del grupo de recursos.",
	"The tag name must be in a key:value format": "El nombre de la etiqueta debe estar en formato clave:valor",
	"The tag name must be in a key:value format.": "El nombre de etiqueta debe estar en un formato de clave:valor.",
	"The window might have been blocked from opening.": "Es posible que se haya bloqueado la apertura de la ventana.",
	"There was a problem loading resource groups.": "Se ha producido un problema al cargar los grupos de recursos.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "Estos roles ofrecen acceso para utilizar el servicio y para realizar llamadas a la API de servicio. Cada rol es personalizado por el servicio seleccionado. Seleccione todos los que procedan. Consulte la documentación del servicio para obtener más información.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "Estos roles son creados por los administradores de la cuenta para personalizar el modo en que se asigna el acceso al servicio. Pulse las Acciones del icono de rol para revisar qué acciones están correlacionadas con este rol.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "Estos roles permiten realizar acciones en recursos de la plataforma, como crear una instancia, conectar una instancia a apps y asignar acceso de usuario. Seleccione todos los que procedan.",
	"This field is required": "Este campo es obligatorio",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "Actualmente no se envía al enviar y está pendiente de una actualización por parte del equipo responsable de la API.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "Así es como se hace referencia a su instancia {{serviceName}} en Event Notifications",
	"This project name \"{{name}}\" already exists, please choose another name.": "Este nombre de proyecto \"{{name}}\" ya existe, por favor elija otro nombre.",
	"This section is under construction, come back later.": "Esta sección está en construcción, vuelva más tarde.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "Este servicio requiere almacenamiento adicional asignado al clúster. No existe ninguna configuración de almacenamiento coincidente.",
	"This tag already exists. Choose another name for your tag.": "Esta etiqueta ya existe. Elija otro nombre para la etiqueta.",
	"This value already exists.": "Este valor ya existe.",
	"This view is not available for some account types": "Esta vista no está disponible para algunos tipos de cuenta",
	"Three zone names are required": "Se necesitan tres nombres de zona",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "Para añadir el cifrado HPCS, siga estos pasos:",
	"To connect, the instance in this region must be configured for platform": "Para conectarse, la instancia de esta región debe estar configurada para la plataforma",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "Para controlar las notificaciones de los sucesos generados por {{serviceName}}, conéctese a una instancia de Event Notifications. <a>Más información</a>",
	"To create a new HPCS key, follow the steps below...": "Para crear una nueva clave HPCS, siga estos pasos...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Total de cuentas",
	"Total estimated cost": "Coste total estimado",
	"Transaction ID": "ID de transacción",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Vuelva a intentarlo más tarde o póngase en contacto con el administrador de su cuenta.",
	"Try again later.": "Vuelva a intentarlo más tarde.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Intente renovar la página y repetir la acción para ver si el problema persiste. Si es así, asegúrese de que está usando un <a>navegador soportado</a> y compruebe la <a>página de estado</a> para ver si está pasando algo más. Si sigue teniendo problemas, póngase en contacto con el <a>soporte</a> para obtener ayuda.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Intente esperar unos minutos y realice la acción de nuevo para ver si el problema continúa. Si lo hace, consulte la <a>página de estado</a> para ver si está pasando algo más. Si sigue teniendo problemas, póngase en contacto con el <a>soporte</a> para obtener ayuda.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Escriba \"{{clusterName}}\" para confirmar",
	"Type \"{{name}}\" to confirm": "Escriba \"{{name}}\" para confirmar",
	"Unable to configure activity tracker event routing.": "No se puede configurar el direccionamiento de sucesos de Activity Tracker",
	"Unable to configure Activity Tracker integration.": "No se ha podido configurar la integración de Activity Tracker.",
	"Unable to configure Logging integration.": "No se puede configurar la integración del registro.",
	"Unable to configure logging.": "No se puede configurar el registro.",
	"Unable to connect your service to Event Notifications service. Try again later.": "No se puede conectar el servicio al servicio Event Notifications. Vuelva a intentarlo más tarde.",
	"Unable to create authorization policy.": "No se puede crear la política de autorización.",
	"Unable to create Satellite location": "No se puede crear la ubicación de Satellite",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "No se puede crear el servicio de política de servicio en este momento. Renueve la página o vuelva a intentarlo más tarde.",
	"Unable to delete cluster": "No se puede eliminar el clúster",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "No se puede desconectar la instancia de Event Notifications. Renueve la página o vuelva a intentarlo más tarde.",
	"Unable to get cluster data": "No se pueden obtener los datos del clúster",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "No se han podido obtener los detalles de la instancia de Event Notifications. Renueve la página o vuelva a intentarlo más tarde.",
	"Unable to get storage instances.": "No se han podido obtener las instancias de almacenamiento.",
	"Unable to list clusters.": "No se pueden mostrar los clústeres.",
	"Unable to list locations.": "No se puede mostrar la lista de ubicaciones.",
	"Unable to load Activity Tracker service catalog data": "No se pueden cargar los datos del catálogo de servicios de Activity Tracker",
	"Unable to load Cloud Logs service catalog data": "No se pueden cargar los datos del catálogo de servicios de Cloud Logs",
	"Unable to load cluster details.": "No se pueden cargar los detalles del clúster.",
	"Unable to load cluster update version options.": "No se pueden cargar las opciones de versión de actualización de clúster.",
	"Unable to load event routing settings": "No se puede cargar la configuración de direccionamiento de sucesos",
	"Unable to load event routing target instances": "No se pueden cargar instancias de destino de direccionamiento de sucesos",
	"Unable to load event routing target instances.": "No se pueden cargar instancias de destino de direccionamiento de sucesos.",
	"Unable to load event routing targets": "No se pueden cargar los objetivos de direccionamiento de sucesos",
	"Unable to load event routing targets.": "No se pueden cargar los objetivos de direccionamiento de sucesos.",
	"Unable to load IBM Cloud locations data": "No se pueden cargar los datos de las ubicaciones de IBM Cloud",
	"Unable to load logging instances": "No se pueden cargar instancias de registro",
	"Unable to load logging instances.": "No se pueden cargar las instancias de registro.",
	"Unable to load logging service catalog data": "No se pueden cargar los datos del catálogo de servicios de registro",
	"Unable to load logs routing targets": "No se pueden cargar los registros de los objetivos de enrutamiento",
	"Unable to load logs routing targets.": "No se pueden cargar los registros de los objetivos de direccionamiento.",
	"Unable to perform": "No se puede realizar",
	"Unable to retrieve cluster details": "No se pueden recuperar los detalles del clúster",
	"Unable to retrieve data": "No se pueden recuperar los datos",
	"Unable to retrieve location information.": "No se puede recuperar la información de ubicación.",
	"Unable to retrieve project configurations.": "No se pueden recuperar las configuraciones del proyecto.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "No se puede enviar la notificación de prueba a la instancia de Event Notifications. Vuelva a intentarlo más tarde.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "No se puede enviar la notificación de prueba a la instancia de Event Notifications. Compruebe si los temas están configurados en Event Notifications.",
	"Unable to update cluster version.": "No se puede actualizar la versión del clúster.",
	Unknown: Unknown,
	"unknown state": "estado desconocido",
	"Unselect all rows": "Deseleccionar todas las filas",
	"Unselect row": "Deseleccionar fila",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Versión no soportada. Actualice la versión para que siga recibiendo soporte.",
	"Upcoming scheduled events in your timezone": "Próximos sucesos planificados en su zona horaria",
	Update: Update,
	"Update available": "Actualización disponible",
	"Update cluster version": "Actualizar versión de clúster",
	"Update tags": "Actualizar etiquetas",
	"Update version": "Actualizar versión",
	"Updating...": "Actualizando...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Actualice su cuenta para ver el periodo de facturación.",
	"Usage based charges apply per gigabyte of audit events ingested.": "Se aplican tarifas basadas en el uso por gigabyte de sucesos de auditoría ingeridos.",
	"Usage based charges apply per gigabyte of logs ingested.": "Se aplican tarifas basadas en el uso por gigabyte de registros ingeridos.",
	"Usage costs": "Costes de utilización",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Utilice un secreto para gestionar de forma segura y centralizada las credenciales de autenticación. <a>Más información</a>",
	"Use a secret?": "¿Usar un secreto?",
	"Use existing": "Utilizar existente",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Utilice los alias de clave para identificar fácilmente las claves. Un alias de clave es un nombre personalizado exclusivo y fácilmente reconocible.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Utilice etiquetas para organizar sus recursos. Si las etiquetas de usuario están relacionadas con la facturación, considere la posibilidad de escribir las etiquetas como pares clave:valor para ayudar a agrupar etiquetas relacionadas, como por ejemplo",
	"Use the options below to choose the item that the reference will be created for.": "Utilice las opciones siguientes para elegir el elemento para el que se creará la referencia.",
	"User evaluation required": "Evaluación de usuario necesaria",
	"User permissions failure": "Fallo en los permisos de usuario",
	"User tags": "Etiquetas de usuario",
	"User tags (optional": "Etiquetas de usuario (opcional",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "Las etiquetas de usuario son visibles en toda la cuenta. Evite incluir datos confidenciales en el nombre de la etiqueta.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "El valor debe ser una matriz válida (por ejemplo, [\"matriz\"]). Para especificar una matriz nula, utilice \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Verifique que se hayan instalado los servicios siguientes en la ubicación: {{missingServices}}.",
	Version: Version,
	View: View,
	"View all": "Ver todo",
	"View audit events": "Ver sucesos de auditoría",
	"View docs": "Ver documentos",
	"View error information": "Ver la información de error",
	"View logging": "Ver registro",
	"View-only mode": "Modalidad de solo visualización",
	"VPC Gen1": "VPC Gen1",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "estado de aviso",
	"Washington DC": "Washington DC",
	Wednesday: Wednesday,
	"What you will need:": "Qué necesitará:",
	"What's the purpose of this project?": "¿Qué finalidad tiene este proyecto?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "Cuando se suprime el clúster, todos los nodos trabajadores, aplicaciones y contenedores se suprimen permanentemente. Esta acción no se puede deshacer. Antes de continuar, asegúrese de hacer una copia de seguridad de todos los datos y archivos de configuración necesarios.",
	"Worker count": "Recuento de nodos de trabajo",
	Workloads: Workloads,
	"Wrong Syntax": "Sintaxis incorrecta",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "Ya tiene una ubicación con este nombre. Especifique un nombre exclusivo.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Ya tiene una instancia de Security and Compliance Center. Para ver los resultados, debe planificar la primera exploración creando un archivo adjunto.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "No puede modificar esta política debido a su nivel de acceso al recurso de la política. Si desea tener la posibilidad de modificar, póngase en contacto con el administrador para que actualice su acceso a los recursos.",
	"You can find a list of resources here once you create them.": "Puede encontrar una lista de recursos aquí una vez que los haya creado.",
	"You can find your resource details here after you create them.": "Puede encontrar los detalles del recurso aquí después de crearlos.",
	"You can find your resources here after you create them.": "Aquí encontrará sus recursos después de crearlos.",
	"You can find your Satellite locations here after you create them.": "Aquí encontrará las ubicaciones de Satellite después de crearlas.",
	"You do not have access to any resource groups.": "No tiene acceso a ningún grupo de recursos.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "No tiene acceso a ningún grupo de recursos. <a>Crear</a> un grupo de recursos.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "No tiene permiso para editar etiquetas. Póngase en contacto con el administrador si necesita un mayor acceso.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "No tienes el acceso correcto para añadir una configuración en \"{{project}}\"",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "Tiene acceso restringido y es posible que no pueda añadir o eliminar etiquetas. Póngase en contacto con el administrador si necesita un mayor acceso.",
	"You haven't connected an Event Notifications service instance yet.": "Todavía no ha conectado una instancia de servicio de Event Notifications.",
	"You may also <a>create an instance</a>.": "También puede <a>crear una instancia</a>.",
	"You may also create a new one.": "También puede crear uno nuevo.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "Puede tener restricciones basadas en contexto o políticas de IAM habilitadas. Póngase en contacto con el administrador de la cuenta.",
	"You must have at least one active root key. Try creating a new one.": "Debe tener al menos una clave raíz activa. Intente crear uno nuevo.",
	"You need at least 1 topic to send a test notification.": "Necesita al menos 1 tema para enviar una notificación de prueba.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "Necesita el rol de Editor o Administrador en el servicio de proyectos de IBM Cloud para este proyecto. <a>Asígnese acceso</a> o solicite acceso al administrador de la cuenta.",
	"You're adding tags to:": "Está añadiendo etiquetas a:",
	"You're editing tags for:": "Está editando etiquetas para:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "No tiene autorización para conectarse a esta instancia. Verifique los permisos o póngase en contacto con el administrador.",
	"You're using the newest version of the API server. There are no updates available at this time.": "Está utilizando la versión más reciente del servidor de API. En este momento no hay ninguna actualización disponible.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "Se ha alcanzado el número máximo de etiquetas que puede adjuntar a la vez. Para adjuntar más etiquetas, guarde primero los cambios.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Su servidor API se está actualizando a la versión {{version}}. Cuando termine, puede actualizar los nodos trabajadores a la misma versión.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Acercar imagen",
	"Zoom out image": "Alejar imagen"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, es as default, hour, hr, mo, more, provided, region, resources, tag, tags };
